module.exports = __webpack_public_path__ + "static/img/global_doublepay@3x.24808c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_doublepay@3x.png
// module id = xp/B
// module chunks = 1